<script>
import { feedbackComputed, feedbackMethods } from '@state/helpers/feedback'
import { STATUS_REQUEST } from '@utils/constant'
import cloneDeep from 'lodash/cloneDeep'
import feedbackItems, { feedbackFields } from './feedbackItems'
import UploadImg from './upload-img.vue'

export default {
  page: {
    title: 'Feedback',
    meta: [{ name: 'description', content: 'The Feedback page.' }],
  },
  components: {
    UploadImg,
  },
  data() {
    return {
      items: null,
      placeholder: this.$t('common.upload_image'),
      resetPlaceholder: false,
      fields: feedbackFields,
      image: '',
      imageFilename: '',
      openConfirm: false,
      title: this.$t('pages.feedback'),
    }
  },
  computed: {
    ...feedbackComputed,
    errorServerSideComputed() {
      return this.getErrors
    },
    companyAgent() {
      const user = this.$store.getters['auth/getCurrentUser']
      return user?.agent.company
    },
  },
  watch: {
    getStatus() {
      if (this.getStatus === STATUS_REQUEST.SUCCESS) {
        this.resetFeedback()
      }
    },
  },
  mounted() {
    this.initItems()
  },
  created() {
    const user = this.$store.getters['auth/getCurrentUser']
    this.$router
      .replace({
        query: { agent_code: user?.agent?.agent_code },
      }) // eslint-disable-next-line handle-callback-err
      .catch(() => {})
  },
  methods: {
    ...feedbackMethods,
    initItems() {
      this.items = cloneDeep(feedbackItems)
    },
    handleUploadImage(imageBinary, fileName) {
      this.fields.image = imageBinary
      this.fields.image_filename = fileName
    },
    async handleAddFeedback() {
      const data = this.items.reduce((results, item) => {
        if (item.key === 'company') {
          results[item.key] = this.companyAgent
        } else if (item.key === 'image') {
          results[item.key] = this.fields.image
        } else {
          results[item.key] = item.value
        }
        return results
      }, {})
      const payload = { ...data, image_filename: this.fields.image_filename }
      const response = await this.registrationFeedback(payload)
      if (response) {
        this.openConfirm = true
      }
    },
    resetFile() {
      this.resetPlaceholder = true
      this.fields.image = ''
      this.fields.image_filename = ''
    },
    handleDirect() {
      this.$router.push({ path: '/panel/dashboard' })
    },
  },
}
</script>

<template>
  <div>
    <BaseAddNewCard
      :errors="errorServerSideComputed"
      type="feedback"
      @submit="handleAddFeedback"
    >
      <template v-slot:header>
        <h5 class="card-title">{{ title }}</h5>
      </template>
      <template v-slot>
        <CRow v-for="item in items" :key="item.key">
          <CCol sm="3">
            {{ item.label }}
            <span v-if="item.rules" class="text-danger">*</span>
          </CCol>
          <CCol :sm="item.as === 'area' ? 9 : 4">
            <BaseInput
              v-if="item.as === 'plaintext'"
              :value="companyAgent"
              plaintext
            />
            <BaseInput
              v-if="item.as === 'input'"
              v-model="item.value"
              :rules="item.rules"
              :name="item.name"
              :vee-name="item.name"
              autocomplete="off"
            />
            <BaseSelect
              v-if="item.as === 'select'"
              :rules="item.rules"
              :name="item.name"
              :vee-name="item.name"
              :options="item.options"
              :value.sync="item.value"
              :default-value="item.options[0].value"
            />
            <UploadImg
              v-if="item.as === 'inputFile'"
              :name="item.name"
              :reset-placeholder="resetPlaceholder"
              :show-reset-button="
                item.key === 'image' &&
                  (!!fields[item.key] || !!fields.image_filename)
              "
              @upload:reset="resetFile"
              @upload:change="handleUploadImage"
            />
            <BaseTextarea
              v-if="item.as === 'area'"
              v-model="item.value"
              :rules="item.rules"
              :name="item.name"
              :vee-name="item.name"
              autocomplete="off"
            />
          </CCol>
        </CRow>
      </template>
      <template v-slot:action>
        <CButton color="dark" variant="outline" type="submit">
          送信
        </CButton>
      </template>
    </BaseAddNewCard>
    <BaseModalConfirm
      id="modal-wait"
      type="wait"
      :show.sync="openConfirm"
      @submit="handleDirect"
    >
    </BaseModalConfirm>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .custom-file-label {
  padding-right: 75px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#modal-wait {
  ::v-deep .btn-light {
    display: none !important;
  }
}
.card-title {
  margin-bottom: 0 !important;
  font-weight: 600;
  color: #73818f;
}
</style>
